import { useState } from "react";
import { MarcacaoMercadoInputCard, ResultadoMarcacao } from "./components/MarcacaoMercadoInputCard";
import { MarcacaoMercadoResponse } from "./components/MarcacaoMercadoResponse";

export default function MarcacaoMercado() {
  const [resultado, setResultado] = useState<ResultadoMarcacao | null>(null);

  return (
    <>
      <MarcacaoMercadoInputCard setResultado={setResultado} />
      {resultado && <MarcacaoMercadoResponse resultado={resultado} />}
    </>
  );
}
